import React from "react";
import styled from 'styled-components';

const TableStyle = styled.div`
    width: 100%;
    .table{
        overflow: hidden;
        border-collapse:collapse;
        width: 95%;
        margin: 2% 2.5%;
        color: var(--text-2);
        td{
            padding: 1rem;
            
            &:nth-child(odd){
                color: var(--text-2);
                vertical-align: top;
                width: 20%;
                border-radius: 0 20px 20px 0;
                border-left: 1px solid #00000010
            }
            &:nth-child(even){
                width: fit-content;
                border-radius: 20px 0 0 20px;
                padding-right: 2rem;
            }
            &.exact {
                width: auto;
            }
        }
        tr{
            border-radius: 20px;
            border-bottom:1px solid #00000010;
            :last-child{
                border-bottom: none;
            }
            
        }
    }
    @media screen and (max-width: 1025px) {
        .table{
            width: 95%;
            td{
                padding: 0.5rem;
            }
        }
    }

    @media screen and (max-width: 850px) {
        .table{
            td{
                &:nth-child(odd){
                    width: 50%;
                }
                &.exact {
                    width: auto;
                }
            }
        }
    }
`;
const Table =(props)=>{
    const columnMaker = (row) => {
        return row.map((value, index) => {
            return (
                <td key={index} className={(row.length > 2) ? "exact" : ""}>
                    {value}
                </td>
            )
        })
    }
    const rowMaker = () => {
        let data = props.data;
        return data.map((value, index) => {
            return (
                <tr key={index}>
                    {columnMaker(value)}
                </tr>
            )
        })
    }
    return(
        <TableStyle>
            <table className='thin-text table'>
                <tbody>
                    {rowMaker()}
                </tbody>
            </table>
        </TableStyle>
        )

}
export default Table;